import React from "react";
import ReactDOM from "react-dom";
import Router from "./router/index";
import "./assets/css/index.scss";
import "antd/dist/antd.css";
import reportWebVitals from "./reportWebVitals";

// let vConsole = new VConsole();

ReactDOM.render(<Router />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
